import React, {useState} from 'react';
import { Container, Tab, Row, Col,  Form, Button } from 'react-bootstrap';
import { Stage, Layer, Image , Text, Transformer } from 'react-konva';
import useImage from 'use-image';
import ImageUploader from 'react-images-upload';
import FontPicker from "font-picker-react";
import mug from '../../../../assets/images/mug.jpg'
// import { Editor } from 'react-draft-wysiwyg';
// import './../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import "./cup.scss";
import { Link } from 'react-router-dom';

import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";



const TextRect = ({text,font,color,fontFamily,alignment,shapeProps,isSelected, onSelect, onChange,onDragEndM,onDragStartM,onDragEndMove  }) => {  
	const shapeRef = React.useRef();
  	const trRef = React.useRef();
  	React.useEffect(() => {    
		if (isSelected) {
		// we need to attach transformer manually
		trRef.current.nodes([shapeRef.current]);
		trRef.current.getLayer().batchDraw();
		}
  	}, [isSelected]);
	return (
		<React.Fragment>
			<Text
				text={text}
				fill={color}
				onDragStart={(e) => {onDragStartM(true)}}
				fontSize={font}
				fontFamily={fontFamily}
				align={alignment}
				width ={100}
				height ={100}
				shadowOffset={{x:1,y:1}}
				onClick={onSelect}
				onTap={onSelect}
				ref={shapeRef}
				{...shapeProps}
				draggable
				onDragEnd={(e) => {
					onDragEndM(false)
					onChange({
						...shapeProps,
						x: e.target.x(),
						y: e.target.y(),
					});
				}}
				onTransformEnd={(e) => {
					// transformer is changing scale of the node
					// and NOT its width or height
					// but in the store we have only width and height
					// to match the data better we will reset scale on transform end
					const node = shapeRef.current;
					const scaleX = node.scaleX();
					const scaleY = node.scaleY();
				
					// we will reset it back
					node.scaleX(1);
					node.scaleY(1);
					onChange({ 
						x: node.x() ,
						y: node.y() ,
						// set minimal value
						width: Math.max(5, node.width() * scaleX) ,
						height: Math.max(5, node.height() * scaleY) ,
					});
					onDragEndMove(false,node)
				}}
			
			/>
			{isSelected && (
				<Transformer
					ref={trRef}
					boundBoxFunc={(oldBox, newBox) => {
						// limit resize
						if (newBox.width < 5 || newBox.height < 5) {
							return oldBox;
						}
						return newBox;
					}}
				/>
			)}
		</React.Fragment>
	);
}

const ImageBg = ({selectedImg,shapeProps,isSelected, onSelect, onChange,onDragEndM,onDragStartM,onDragEndMove }) => {  
	const [image] = useImage(selectedImg,'Anonymous');
	const [isDragging,setIsDragging] = useState(false);
	const [imageWidth,setImageWidth] = useState(0);
	const [imageHeight,setImageHeight] = useState(0);
	const [imageX,setImageX] = useState(570);
	const [imageY,setImageY] = useState(230);
	const shapeRef = React.useRef();
	const trRef = React.useRef();
	React.useEffect(() => {
		setImageWidth(shapeProps && shapeProps.width?shapeProps.width:(image?(image.width > 150?150:image.width):0))
		setImageHeight(shapeProps && shapeProps.height?shapeProps.height:(image?(image.height > 150?(image.height * (150/image.width)):image.height):0))
		setImageX(shapeProps && shapeProps.x?((shapeProps.x > 250 || shapeProps.x < 100)?150:shapeProps.x):200)
		setImageY(shapeProps && shapeProps.y?((shapeProps.y > 550 || shapeProps.y < -50)?200:shapeProps.y):200)
  		if (isSelected) {
    		// we need to attach transformer manually
    		trRef.current.nodes([shapeRef.current]);
    		trRef.current.getLayer().batchDraw();
  		}
	}, [isSelected,image,imageWidth,setImageWidth,imageHeight,setImageHeight,shapeProps]);
    return (
      	<React.Fragment>
			<Image
				image={image}
				fill={isDragging ? 'green' : ''}
				onDragStart={(e) => {
					setIsDragging(true)
					onDragStartM(true)
				}}
				onClick={onSelect}
				onTap={onSelect}
				isSelected={'img'}
				ref={shapeRef}
				{...shapeProps}
				x={imageX}
				y={imageY}
				draggable
				width={imageWidth}
				height={imageHeight}
				onDragEnd={(e) => {
					onDragEndM(false)
					setIsDragging(false)
					onChange({
						...shapeProps,
						x: (e.target.x() > 250 || e.target.x() < 100)?150:e.target.x(),
						y: (e.target.y() > 550 || e.target.y() < -50)?200:e.target.y(),
					});
					
				}}
				onTransformEnd={(e) => {
					// transformer is changing scale of the node
					// and NOT its width or height
					// but in the store we have only width and height
					// to match the data better we will reset scale on transform end
					const node = shapeRef.current;
					const scaleX = node.scaleX();
					const scaleY = node.scaleY();

					// we will reset it back
					node.scaleX(1);
					node.scaleY(1);
					onChange({						
						x: node.x() ,
						y: node.y() ,
						// set minimal value
						width: Math.max(5, node.width() * scaleX) ,
						height: Math.max( node.height() * scaleY) ,
					});
					onDragEndMove(false,node)
				}}				
			/>
			{isSelected && (
				<Transformer
					ref={trRef}
					boundBoxFunc={(oldBox, newBox) => {
						// limit resize
						if (newBox.width < 5 || newBox.height < 5) {
							return oldBox;
						}
						return newBox;
					}}
				/>
			)}
        </React.Fragment>
    );
}




const initialText = {
    x: 100,
    y: 100,
    id: 'txt',
};
	
const initialImage = {
    x: 100,
    y: 100,
    id: 1,
};


const Cup = (pData ) => {
	// const downloadURI = (uri, name) => {
	// 	var link = document.createElement('a');
	// 	link.download = name;
	// 	link.href = uri;
	// 	document.body.appendChild(link);
	// 	link.click();
	// 	document.body.removeChild(link);
	// }

	const stageRef = React.useRef(null);
	// const handleExport = () => {
	// 	const uri = stageRef.current.toDataURL();
	// 	return uri;
	// 	// downloadURI(uri, 'stage.png');
	// };
	const resizeImage = (base64Str) => {
		
		return new Promise((resolve) => {
			let imgD = new window.Image()
			imgD.src = base64Str
		  
			imgD.onload = () => {
				let canvas = document.createElement('canvas')
				let width = imgD.width
				let height = imgD.height
				// const MAX_WIDTH = maxWidth
				// const MAX_HEIGHT = maxHeight
				// let width = imgD.width
				// let height = imgD.height
		
				// if (width > height) {
				// if (width > MAX_WIDTH) {
				// 	height *= MAX_WIDTH / width
				// 	width = MAX_WIDTH
				// }
				// } else {
				// if (height > MAX_HEIGHT) {
				// 	width *= MAX_HEIGHT / height
				// 	height = MAX_HEIGHT
				// }
				// }
				canvas.width = width
				canvas.height = height
				let ctx = canvas.getContext('2d')
				ctx.drawImage(imgD, 0, 0, width, height)
				resolve(canvas.toDataURL())
			}
		})
	}

	const [images, setImages] = React.useState([initialImage]);
	const [texts, setTexts] = React.useState(initialText);
	const [textData, setTextData] = React.useState('');
	const [selectedId, selectShape] = React.useState('');  
  	const [selectedTextId, selectText] = React.useState('txt');
  	const [fontSize, setFontSize] = React.useState(14);
  	const [fontFamily, setFontFamily] = React.useState("Open Sans");
	const [color, setColor] = React.useState('#000000');
	const [alignment, alignText] = React.useState('left');
	const [textNode,settextNode] = React.useState(null);
	const [imgNode,settimgNode] = React.useState([]);
	const [dwidth,setWidth] = React.useState(570);
	const [dheight,setDheight] = React.useState(230);
	const[videoPopUp, setVideoPopUp] = React.useState(false)
	// const [textAllData,setTextAllData] = React.useState([]);
	// const [imgAllData,setimgAllData] = React.useState([]);
	// if(images.length === 0){
	// 	let arr = pData.imageUrlData.map(item=> item.props)
	// 	setImages(arr);
	// }

	// let arr = pData.imageUrlData.map(item=> item.props)
	// setImages(arr);
	React.useEffect(() => {
		if(document.getElementById('container').offsetWidth < 600){
			setWidth(326)
			setDheight(133)
		}
	}, [setDheight,setWidth])

	const addToCard = () =>{
		let imgobj = {
			imgNode:[imgNode],
			img:[pData.imageUrlData],
		}
		let txtobj = {
			txtNode:[textNode],
			text:[texts],
			fontFamily:[fontFamily],
			fontSize:[fontSize],
			fontColor:[color],
			alignment:[alignment]
		}
		// setimgAllData([...imgobj])
		// setTextAllData([...txtobj]);
		pData.pData[0]['image_json'] = imgobj;
		pData.pData[0]['text_json'] = txtobj;
		setTimeout( async ()=>{
			let img = stageRef.current.toDataURL({ pixelRatio: 3 });
			let resize = await resizeImage(img,500,500).then(result => result);
			pData.pData[0]['thumbnail'] = resize;
		},1000)
		setTimeout(()=>{
			pData.addToCart(pData.pData[0])
		},2000)
	}


	const checkDeselect = (e) => {            
		// setDragging(true)
	};


	const clickVideo =()=>{
		setVideoPopUp(true)
	}

	const onCloseModal=()=>{
		setVideoPopUp(false)
	}

	const closeIcon = (

		<i className="fa fa-times closeIconbgVideo" aria-hidden="true"></i>
	);

  	return (
		<Container id="container">
			<Row>
				<Col sm={6} className="canvasContainerMug postion-abs marg-top-65">
					<div className="text-center" style={{background:"url("+mug+")"}}>
						<Stage
							onMouseDown={checkDeselect}
							onTouchStart={checkDeselect}					
							ref={stageRef}
							width={dwidth} height={dheight} >
							<Layer>					
								{/* <Portal selector=".top-layer" enabled={isDragging}> */}
								{pData.imageUrlData.length > 0  &&
									pData.imageUrlData.map((item,index)=>
										<ImageBg
											key={index}
											selectedImg={item.image}
											shapeProps={images[index]}
											isSelected={item.props.id === selectedId}
											onSelect={() => {
												selectShape(item.props.id);
											}}
											onChange={(newAttrs) => {
												const rects = newAttrs;
												let im = images;
												im[index] = rects
												setImages(im);
												pData.updateImageProps(rects,index)
											}}
											onDragStartM={(e)=>{
													// setDragging(e)
													selectShape(null);
												}
											}
											onDragEndM={(e)=>{
													// setDragging(e)
													selectShape(null);
												}
											} 
											onDragEndMove={(e,node)=>{
												// setDragging(e)
												settimgNode([...imgNode,node])
												}
											}
										/>  
									)
									
								}     
								{textData !== '' &&     
									<TextRect 
										text={textData}
										font={fontSize}
										color={color}
										fontFamily={fontFamily}
										alignment={alignment}
										shapeProps={texts}
										isSelected={selectedTextId}
										onSelect={() => {
											selectText(texts.id);
										}}
										onChange={(newAttrs) => {
											const rects = newAttrs;
											setTexts(rects);
										}}
										onDragStartM={(e)=>{
												// setDragging(e)
												selectText(null);
											}
										}
										onDragEndM={(e)=>{
												// setDragging(e)
												selectText(null);
											}
										}
										onDragEndMove={(e,node)=>{
											// setDragging(e)
											settextNode(node)
											}
										}
									/>
								}
								{/* </Portal>										 */}
								{/* <FixShape  bgImage={} width={dwidth} height={dheight} /> */}
							</Layer>							
							{/* <Layer name="top-layer" /> */}
						</Stage>
					</div>
				</Col>
		
				<Col sm={6}>
					<Tab.Container id="left-tabs-example" defaultActiveKey="first">
					<Row>
						<Col sm={12}>
							<div className="product-single-details ml-5">
								<div className="display-tips">
									<h1 className="product-title font-capital cstmiz-mug fnt-size-15">{pData.pData[0].name}</h1>
									<Link className="tips-a fnt-size-10" to={'/tips-on-designing-mugs'} target='_blank'>Tips On Designing</Link>

									<span  className="tips-a fnt-size-10 videoClick" onClick={()=>clickVideo()}>How To Designing</span>

								</div>
								
								<Modal open={videoPopUp} onClose={onCloseModal} closeIcon={closeIcon}>
									<iframe  className="ifremaWidth-hight" title="mug" src="https://www.youtube.com/embed/I6ea5-__osg" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>                                   
								</Modal> 
								
								{/* End .product-container */}

								<div className="price-box">
										<span className="old-price">
												<i className="fa fa-rupee-sign " aria-hidden="true"></i>
												{pData.pData[0].price}.00
										</span>
										<span className="product-price color-price">
												<i className="fa fa-rupee-sign" aria-hidden="true"></i>
												{pData.pData[0].sale_price}.00
										</span>
								</div>
								{/* End .price-box */}

								{/* <Nav variant="pills" className="flex-row">
									<Nav.Item>
										<Nav.Link eventKey="first" className="btn btn-primary bg-bd-color">Image</Nav.Link>
									</Nav.Item>
									<Nav.Item>
										<Nav.Link eventKey="second" className="btn btn-primary bg-bd-color">Text</Nav.Link>
									</Nav.Item>
									
								</Nav> */}
								<Tab.Content>
									<Tab.Pane eventKey="second">
										{/* <h4 className="widget-title">
											Add New Text
										</h4> */}
										<div >
											{/* <Form.Group>
												<Form.Label>Add New Text</Form.Label>
												<textarea className="form-control text-height-width textAreaSize"  onChange={(e) => setTextData(e.target.value)} value={textData} placeholder="Type something here" rows="1"/>
											</Form.Group> */}

											<div className="col-md-12">
												<div className="row pt-2">
													<div className="col-md-3">
														<span className="p-field">
															<Form.Label>Add New Text</Form.Label>
														</span>
													</div>
													<div className="col-md-9 pl-0">
														<textarea className="form-control textAreaSize text-height-width" onChange={(e) => setTextData(e.target.value)} value={textData} placeholder="Type something here" rows="1" />
													</div>
												</div>
											</div>

											{/* <span className="p-field">
												<label htmlFor="text">Text Align</label>
												<span className="btn-group ml-5">
														<Button label=""  className="btn-sm bg-pd-text-align" onClick={() => alignText('left')}><i className="fa fa-align-left"></i></Button>
														<Button label=""  className="btn-sm bg-pd-text-align" onClick={() => alignText('center')} ><i className="fa fa-align-center"></i></Button>
														<Button label=""  className="btn-sm bg-pd-text-align" onClick={() => alignText('right')} ><i className="fa fa-align-right"></i></Button>
														<Button label=""  className="btn-sm bg-pd-text-align" onClick={() => alignText('justify')} ><i className="fa fa-align-justify"></i></Button>
												</span>
											</span> */}

											<div className="col-md-8">
												<div className="row">
													<div className="col-md-4">
														<span className="p-field">
															<label htmlFor="text">Text Align</label>
														</span>
													</div>
													<div className="col-md-4">
														<span className="btn-group">
															<Button label=""  className="btn-sm bg-pd-text-align" onClick={() => alignText('left')}><i className="fa fa-align-left"></i></Button>
															<Button label=""  className="btn-sm bg-pd-text-align" onClick={() => alignText('center')} ><i className="fa fa-align-center"></i></Button>
															<Button label=""  className="btn-sm bg-pd-text-align" onClick={() => alignText('right')} ><i className="fa fa-align-right"></i></Button>
															<Button label=""  className="btn-sm bg-pd-text-align" onClick={() => alignText('justify')} ><i className="fa fa-align-justify"></i></Button>
														</span>
													
													</div>
												</div>
											</div>

											{/* <Form.Group>
												<Form.Label>Font Size</Form.Label>
												<Form.Control type="range" onChange={(e) => setFontSize(e.target.value)} value={fontSize} placeholder="" />
											</Form.Group> */}

											<div className="col-md-8">
												<div className="row pt-2">
													{/* <Form.Group> */}
														<div className="col-md-4">
															<span className="p-field">
																<Form.Label>Font Size</Form.Label>
															</span>
														</div>
														<div className="col-md-4">	
															<Form.Control type="range" className="rangeWdth"  onChange={(e) => setFontSize(e.target.value)} value={fontSize} placeholder="" />
															</div>
													{/* </Form.Group> */}
												</div>
											</div>

											{/* <Form.Group>
												<Form.Label>Font Color</Form.Label>
												<Form.Control type="color" onChange={(e) => setColor(e.target.value)} value={color} placeholder="" />
											</Form.Group> */}

											<div className="col-md-8">
												<div className="row pt-2">
													<div className="col-md-4">
														<span className="p-field">
															<Form.Label>Font Color</Form.Label>
														</span>
													</div>
													<div className="col-md-4">
														<Form.Control type="color" className="rangeWdth" onChange={(e) => setColor(e.target.value)} value={color} placeholder="" />
													</div>
												</div>
											</div>

											{/* <Form.Group>
												<Form.Label>Font Family</Form.Label>
												<FontPicker
													apiKey="AIzaSyA94amz2aeB9v66mvhYBEPVubflbyN6z-k"
													className="form-control"
													activeFontFamily={fontFamily}
													onChange={(nextFont) =>
															setFontFamily(nextFont.family)
													}
											/>
											</Form.Group> */}

											<div className="col-md-8">
												<div className="row pt-2">
													<div className="col-md-4">
														<span className="p-field">
															<Form.Label>Font Family</Form.Label>
														</span>
													</div>
													<div className="col-md-4">
														<FontPicker
															apiKey="AIzaSyA94amz2aeB9v66mvhYBEPVubflbyN6z-k"
															className="form-control"
															activeFontFamily={fontFamily}
															onChange={(nextFont) =>
																	setFontFamily(nextFont.family)
															}
														/>
													</div>
												</div>
											</div>
										</div>
									</Tab.Pane>
									<Tab.Pane eventKey="first">
									
											
												{/* <h4 className="widget-title">
													UPLOAD ART
												</h4> */}
												<div className='wdt-100'>
													<table  className="variations" cellSpacing="0">
														<tbody>
															<tr>
																<td className="label ">
																	<label htmlFor="pa_color" className="col-md-3">Photo</label>
																</td>
																<td  className="value">
																	<div className='col-md-9'>
																		<ImageUploader
																				withIcon={false}
																				buttonText='Choose images'
																				onChange={(e) =>pData.uploadImage(e,'front') }
																				// setSelectedImg(URL.createObjectURL(e[0]))
																				imgExtension={['.jpg', '.gif', '.png', '.gif','jpeg']}
																				maxFileSize={5242880}
																				singleImage={true}
																				className='imag-po white-space'
																		/>
																	</div>
																</td>
															</tr>
														</tbody>
													</table>
												</div>
												<Col>
												{
													pData.imageUrlData.length > 0 && 
													pData.imageUrlData.map((item,i)=>(

													
													<div className="uploadImageCupRemove" key={i}>
														<img src={item.image} alt="uploadImg" width="70px" />
														<span onClick={() => pData.remImg(i)} className="fa fa-trash removeImageCup"></span>
													</div>))
												}
											</Col>
									</Tab.Pane>
								</Tab.Content>

								{/* Product Option Select Start*/}

										
								<div className="product-action product-all-icons mrg-top-100 pt-5">
									<div className="product-single-qty" style={{"display":"flex"}}>
											<button className="btn btn-outline" disabled={pData.qty === 1} onClick={()=> pData.setQty(pData.qty-1)}>-</button>

											<input className="horizontal-quantity form-control" type="text" value={pData.qty} placeholder='qty' readOnly/>
											
											<button className="btn btn-outline" onClick={()=> pData.setQty(pData.qty < 20? pData.qty+1:pData.qty)}>+</button>
									</div>
									{/* End .product-single-qty */}

									
									
									<div className="paction add-cart show-color detais-btn pointer" title="Add to Cart" onClick={addToCard}>
										<span>Add to Cart</span>
									</div>
								</div>
							</div>
							{/* End .product-single-details */}
							
						</Col>
					</Row>
				</Tab.Container>
				</Col>
					</Row>

		</Container>
  );
}


export default  Cup